import { IDocument, IDocumentCategory } from '@/interfaces/documents'
import { mapFileFields, mapImageFields } from '@/adapters/common'

export function mapDocumentCategoryFields(item: Directus.DocumentCategory): IDocumentCategory {
  return {
    id: item.id,
    ...item.translations[0],
  }
}

export function mapDocumentFields(item: Directus.Document, locale?: string): IDocument | null {
  const file = mapFileFields(item.file)
  const fileRu = mapFileFields(item.file_ru)
  const imagePreview = mapImageFields(item.image_preview)
  const imagePreviewRu = mapImageFields(item.image_preview_ru)

  if (!file) return null

  return {
    year: item.year,
    file: locale === 'ru-RU' && fileRu ? fileRu : file,
    image_preview: locale === 'ru-RU' && imagePreviewRu ? imagePreviewRu : imagePreview,
    category: item.category ? mapDocumentCategoryFields(item.category) : null,
    ...item.translations[0],
  }
}
